import { readOnly } from '@ember/object/computed';
import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import { hash } from 'rsvp';

import { Crumb } from 'cio/services/crumbs';
import MetricsService from 'cio/services/metrics';
import { Entities, MetricTypes } from 'cio/utils/metrics/common';
import ActionModel from 'cio/models/action';
import { SplitMetric } from 'cio/utils/metrics/models/split-metric';
import Transition from '@ember/routing/-private/transition';
import DS from 'ember-data';

type BaseOverviewTestsTestRouteModel = {
  actionModel: ActionModel;
  splitMetrics: SplitMetric[];
};

export default class BaseOverviewTestsTestRoute extends Route {
  templateName = 'base/overview/tests/test';

  @service('metrics') metricsService!: MetricsService;
  @service store!: DS.Store;

  crumb(): Crumb | null {
    // fetch campaign model: from "broadcasts.broadcast" (API-triggered broadcasts) or "campaigns.campaign" (regular campaigns) route
    let campaignModel = this.modelFor(this.routeName.split('.').slice(0, 2).join('.'));
    let model = (this.modelFor(this.routeName) as BaseOverviewTestsTestRouteModel).actionModel;

    if ((campaignModel as any).splitTestActions.length === 1) {
      return null;
    }

    return {
      name: readOnly('model.splitTestName'),
      path: this.routeName,
      model,
    };
  }

  model(params: { action_id: string }) {
    return hash({
      actionModel: this.store.findRecord('action', params.action_id),
      splitMetrics: this.metricsService.fetchSplitMetric(params.action_id),
    });
  }

  setupController(controller: any, model: BaseOverviewTestsTestRouteModel, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.set('actionModel', model.actionModel);
    controller.set('splitMetrics', model.splitMetrics);

    controller.set('selectedWinner', null);
    controller.set('selectedStat', controller.get('stats.firstObject'));
  }

  resetController(controller: any, isExiting: boolean, transition: any) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      this.metricsService.clearMetrics(MetricTypes.SplitMetric, Entities.CAMPAIGN, controller.actionModel.get('id'));
    }
  }
}
